/**
 * SYR-90 Phase 7 — The Hypothesis inside the CRM.
 *
 * Research a brand from nothing but a name and a website, read the scorecard,
 * preview the outreach email and send it. It lives here rather than on the AI
 * Hub subsystem page because it is sales work, not model configuration: a
 * prospect researched here becomes a CRM account, and the outreach goes out
 * through the CRM sender and lands on that account's timeline.
 *
 * The AI Hub page keeps what belongs to it — prompts, provider and the feature
 * flag.
 *
 * SYR-107 adds the public lead generator's queue below. The runner and jobs
 * panels above it are filtered to admin-created subjects server-side, so
 * lead-gen traffic cannot bury the outreach prospects an admin actually chose.
 */

import React from 'react';
import { Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useAuth } from '../../../hooks/useAuth';
import { HypothesisRunnerPanel } from '../hypothesis/HypothesisRunnerPanel';
import { HypothesisJobsCard } from '../hypothesis/HypothesisJobsCard';
import { PublicHypothesisLeadsCard } from '../public-hypothesis/PublicHypothesisLeadsCard';
import { ConstraintDistributionCard } from '../public-hypothesis/ConstraintDistributionCard';
import { DomainPolicyCard } from '../public-hypothesis/DomainPolicyCard';

const { Paragraph } = Typography;

export const CrmHypothesisTab: React.FC = () => {
    const { user } = useAuth();
    const jwt = user?.jwtToken || '';

    return (
        <div>
            <Paragraph type="secondary">
                <FormattedMessage
                    id="crm.hypothesis.intro"
                    defaultMessage="Research any brand from its name and website, then send the hypothesis as cold outreach. Sending needs the prospect linked to a CRM account — that is what gives the email a sender, a reply path and a timeline."
                />
            </Paragraph>
            <HypothesisRunnerPanel jwt={jwt} />
            <HypothesisJobsCard jwt={jwt} />
            <ConstraintDistributionCard jwt={jwt} />
            <PublicHypothesisLeadsCard jwt={jwt} />
            <DomainPolicyCard jwt={jwt} />
        </div>
    );
};
